
<template>
  <CModal
     :title="modalModeTitle()"
     :color="modalModeCss()"
     :show.sync="recordModal"
     :closeOnBackdrop=false
   >
      <template #header-wrapper>
        <header class="modal-header">
          <h5 class="modal-title"> {{ modalModeTitle()}}</h5>
        </header>
      </template>
      <CRow class="form-box">
        <CCol sm="12">
          <label class="record-label">問題文</label>
          <CInput
            invalid-feedback="空では登録できません"
            placeholder="例) 次のうち、正しいものを選択してください"
            v-validate="{ required: true, min: 3 }"
            :class="{ 'hasError': $v.record.title.$error }"
            v-model="record.title"
          />
          <small v-if="$v.record.title.$error" class="errorLabel">問題文を入れてください</small>
        </CCol>
      </CRow>
      <CRow class="form-box">
        <CCol sm="12">
          <label class="record-label">問題の種別</label>
          <CSelect
            placeholder="問題の形式を選択してください"
            :class="{ 'hasError': $v.record.question_type.$error }"
            :options="questionTypes"
            :value.sync="record.question_type"
          />
        </CCol>
      </CRow>

      <CRow class="form-box">
        <CCol sm="12">
          <label class="record-label">業種</label>
          <CSelect
            placeholder="問題の業種を選択してください"
            :class="{ 'hasError': $v.record.industry_id.$error }"
            :options="industryTypes"
            :value.sync="record.industry_id"
          />
        </CCol>
      </CRow>

      <CRow class="form-box">
        <CCol sm="12">
          <label class="record-label">中カテゴリー</label>
          <CInput
            placeholder="例) コンクリート圧送"
            v-model="record.midle_category"
          />
        </CCol>
      </CRow>

      <CRow class="form-box">
        <CCol sm="12">
          <label class="record-label">問題内容と回答</label>


          <div v-if="record.question_type != 'true_or_false'">
            <CInput
               v-for="(k, v) in options"
               :key="v"
               type="text"
               :prepend="'選択肢' + (v+1)"
               class="answer-form"
               v-model="k.label"
            >
               <template #append-content>
                 <label class="control control--checkbox">
                   <input type="checkbox" v-if="k.is_answer == true" v-model="k.is_answer" @click="setAnswer(v, false)" checked/>
                   <input type="checkbox" v-else  v-model="k.is_answer" @click="setAnswer(v, true)" />
                   <div class="control__indicator"></div>
                 </label>
               </template>
            </CInput>
          </div>
          <div v-else>

             <CSelect
               placeholder="問題の答えを選択してください"
               :options="trueFalseTypes"
               :value.sync="record.answer"
             />
          </div>

        </CCol>
      </CRow>
      <CRow class="form-box">
        <CCol sm="12">
          <label class="record-label">解説</label>
          <CTextarea
            placeholder="この問題の解説を入力してください"
            :class="{ 'hasError': $v.record.commentary.$error }"
            v-model="record.commentary"
            rows="9"
          />
          <small v-if="$v.record.commentary.$error" class="errorLabel">解説を入れてください</small>
        </CCol>
      </CRow>

      <template #footer>
        <CButton size="sm" @click="hideRecordModal()">キャンセル</CButton>
        <CButton size="sm" v-if="mode=='Create'" color="info" @click="createItem()">登録</CButton>
        <CButton size="sm" v-if="mode=='Edit'" color="info" @click="updateItem()">更新</CButton>
      </template>
   </CModal>
</template>

<script>
import axios from 'axios';
import moment from 'moment';
import { required } from "vuelidate/lib/validators";
import { mapGetters } from 'vuex';
export default {
  name: '',
  props: {
    record:{},
    mode: {
      type: String,
      default: ""
    },
    recordModal: {
      type: Boolean,
      default: false
    },
    industryTypes: {}
  },
  data() {
    return {
      trueFalseTypes: [
        {value: "TRUE", label: "まる"},
        {value: "FALSE", label: "ばつ"},
      ],
      defaultContent: [
        {
            label: "",
            is_answer: false
        },
        {
            label: "",
            is_answer: false
        },
        {
            label: "",
            is_answer: false
        },
        {
            label: "",
            is_answer: false
        },

      ],
      questionTypeLabel: {
          "": "",
          "true_or_false": "丸ばつ問題",
          "radio": "単数選択式",
          "checkbox": "複数選択式",
      },
      questionTypes: [
         {
            value: "",
            label: "",
         },
         {
            value: "true_or_false",
            label: "丸ばつ問題",
         },
         {
            value: "radio",
            label: "単数選択式"
         }
      ],
      options: [],
      answer: false,

    }
  },
  methods: {
    answerValidate: function(r) {
      if(r == "TRUE") {
        return true
      } else {
        return false
      }
    },
    modalModeCss: function() {
      return (this.mode == "Create")? "info" : "dark"
    },
    modalModeTitle: function() {
      return (this.mode == "Create")? "新規問題追加" : "編集"
    },
    showDeleteModal: function(i, index) {
      this.deleteModal = true
      this.record = i
      this.itemIndex = index
    },
    hideRecordModal: function() {
      this.recordModal = false
      this.$emit('hide')
    },
    hideDeleteModal: function() {
      this.deleteModal = false
    },
    formatData: function(label, d) {
        if(label == "created_at" || label == "updated_at") {
          return moment(d).format("YYYY/MM/DD HH:mm")
        } else {
          return d
        }
    },
    createItem: function() {
      this.$v.record.$touch();
      if(this.$v.record.$error) return

      this.record.content = JSON.stringify(this.options)
      this.record.answer = this.getAnswer()
      axios
        .post(process.env.VUE_APP_API_ENDPOINT + "/questions", {"question": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(response => {
           this.recordModal = false
           console.log(response)
           this.$router.go({path: this.$router.currentRoute.path, force: true})

        }).catch(error => {
          this.errorNotify(error.response)
        })
    },
    updateItem: function() {
      this.$v.record.$touch();
      if(this.$v.record.$error) return
      this.record.content = JSON.stringify(this.options)
      this.record.answer = this.getAnswer()

      axios
        .patch(process.env.VUE_APP_API_ENDPOINT + "/questions/" + this.record.id, {"question": this.record}, {headers: {'Authorization': 'Bearer ' + this.idToken}})
        .then(() => {
          this.recordModal = false
          this.record = this.options
        }).catch(error => {
          console.log(error)
        })
    },
    setAnswer: function(v, a) {
      for(var i in this.options) {
        this.options[i].is_answer = false
      }
      this.options[v].is_answer = a
    },
    getAnswer: function() {
      var answer = 0

      if(this.record.question_type != "true_or_false") {
        this.options.forEach((k,v) => {
          if(k['is_answer']) {
            answer = v
          }
        })
      } else {
        answer = this.record.answer
      }
      return answer
    }
  },
  validations: {
    record: {
      title: {required},
      question_type: {required},
      industry_id: {required},
      commentary: {required}
    }
  },
  mounted() {
    this.options = this.record.content

    if(this.record.question_type == "radio") {
      for(var i in this.options) {
        this.options[i].is_answer = false
      }
      this.options[this.record.answer].is_answer = true
    } else {
      if(this.record.answer == "TRUE" || this.record.answer == "true") {
        this.answer = true
      } else if(this.record.answer == "FALSE" || this.record.answer == "false") {
        this.answer = false
      }
    }
  },
  watch: {
    record: function() {
      this.$v.record.$reset();
      if(this.mode == "Edit") {
        this.options = this.record.content
      } else {
        this.options = this.defaultContent
      }
      if(this.record.question_type == "radio") {
        for(var i in this.options) {
          this.options[i].is_answer = false
        }
        this.options[this.record.answer].is_answer = true
      } else {
        if(this.record.answer == "TRUE" || this.record.answer == "true") {
          this.answer = true
        } else if(this.record.answer == "FALSE" || this.record.answer == "false") {
          this.answer = false
        }
      }
    },
    recordModal: function() {},
    mode: function() {
   },
  },
  computed: {
    ...mapGetters({
      idToken:'GetIdToken',
    })
  },
}
</script>

<style scoped lang="scss">

</style>
